export interface GTMState {
  dataLayer: any[];
}

export const initialGTMState: GTMState = { dataLayer: [] };
